var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGermany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 20,
    viewBox: "0 0 34 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "GERMANY_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000135668709428766767390000006023584811776771739_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11472_48389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.8218 0.385742H0.257812V6.90875H33.8218V0.385742Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000135668709428766767390000006023584811776771739__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11472_48389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M33.8218 6.90918H0.257812V13.4362H33.8218V6.90918Z",
    fill: "#E1001F"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000135668709428766767390000006023584811776771739__3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11472_48389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M33.8218 13.4355H0.257812V19.9626H33.8218V13.4355Z",
    fill: "#F6D928"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000135668709428766767390000006023584811776771739__4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11472_48389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_11472_48389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M12.3936 5.01855V12.8546C12.3936 15.7906 16.3345 15.4366 17.0385 16.6086C17.7425 15.4366 21.6855 15.7906 21.6855 12.8546V5.01855H12.3936Z",
    fill: "#F6D728"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_11472_48389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M17.0392 16.6672L17.0153 16.6242C16.7653 16.2102 16.1032 15.9912 15.3362 15.7352C14.0142 15.2972 12.3643 14.7492 12.3643 12.8542V4.99121H21.7152V12.8542C21.7152 14.7492 20.0682 15.2972 18.7422 15.7352C17.9752 15.9912 17.3132 16.2102 17.0642 16.6242L17.0392 16.6672ZM12.4222 5.04822V12.8552C12.4222 14.7072 13.9822 15.2262 15.3572 15.6812C16.1092 15.9332 16.7633 16.1482 17.0403 16.5562C17.3163 16.1482 17.9713 15.9332 18.7263 15.6812C20.0983 15.2262 21.6582 14.7062 21.6582 12.8552V5.04822H12.4222Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_11472_48389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M16.7343 6.14703C16.7813 6.37703 16.6883 6.94004 16.5703 7.13104C16.4533 7.31704 16.1473 7.66802 16.1253 8.02002C16.0073 9.78402 16.6653 12.338 17.0393 14.168C17.4153 12.338 18.0713 9.78302 17.9543 8.02002C17.8393 6.26202 17.6023 5.79102 17.6023 5.79102L16.7343 6.14703Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_8"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_11472_48389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M16.8266 6.40448C16.3896 6.37148 16.0226 6.28348 15.7236 6.14648C15.8486 6.30048 16.1326 6.42547 16.5696 6.51947L16.8266 6.40448Z",
    fill: "#CA001C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_11472_48389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M16.5739 6.50629C16.1279 6.44029 15.8409 6.3133 15.7139 6.1543C16.0269 6.2693 16.3959 6.35729 16.8289 6.38629L16.8269 6.4173C16.3889 6.3843 16.0169 6.2983 15.7199 6.1553C15.8589 6.2873 16.1409 6.41429 16.5739 6.50629Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_10"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_11472_48389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M16.6874 5.43962C15.9834 5.08762 15.5594 5.48863 16.0294 6.12163C16.0774 6.00463 16.5214 5.83862 16.7334 6.40462C16.6254 6.46462 16.3654 6.47262 15.9604 6.42562C16.1704 6.58762 16.8054 6.61362 16.9204 6.54262C17.0384 6.47262 16.7104 5.88662 16.7104 5.88662L16.6874 5.43962Z",
    fill: "#CA001C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_11"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_11472_48389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M16.6533 6.59426C16.4133 6.59426 16.0923 6.54727 15.9503 6.43627C16.3643 6.45827 16.6213 6.45227 16.7263 6.38927C16.5933 6.07527 16.3923 6.02225 16.2843 6.02025C16.2843 6.02025 16.2843 6.02025 16.2823 6.02025C16.1553 6.02025 16.0613 6.08125 16.0433 6.12725C15.8053 5.84425 15.7593 5.57625 15.8903 5.42025C16.0353 5.24825 16.3413 5.25024 16.6933 5.42824L16.6803 5.45327C16.3473 5.28727 16.0453 5.27926 15.9133 5.43926C15.7903 5.58426 15.8383 5.83724 16.0413 6.10924C16.0393 6.05224 16.1593 5.99025 16.2863 5.99025C16.4013 5.99225 16.6163 6.04526 16.7483 6.39626C16.6283 6.47826 16.3714 6.48626 15.9584 6.43926C16.1724 6.57226 16.8003 6.59926 16.9133 6.52926C16.9903 6.48226 16.8203 6.11726 16.6973 5.89226C16.7783 5.97826 17.0523 6.48226 16.9293 6.55626C16.8873 6.58026 16.7813 6.59426 16.6533 6.59426Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_12"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_11472_48389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M17.5573 5.93256C17.6753 5.90956 17.8623 5.83854 18.0023 5.70254C17.7433 5.70254 17.2733 5.55755 17.0853 5.46655C16.8983 5.37055 16.5703 5.16153 16.5703 5.55853C16.5703 5.95853 16.9933 6.26354 16.9213 6.58954L17.5573 5.93256Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_13"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_11472_48389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M16.9707 5.67469C16.9707 5.67469 16.7347 5.5577 16.6887 5.5127C16.6427 5.4657 16.5707 5.77069 16.7817 5.86469C16.8117 5.78369 16.8747 5.72369 16.9707 5.67469Z",
    fill: "#F0F7FF"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_14"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_11472_48389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M16.8057 5.53418C16.6947 5.56718 16.6717 5.65118 16.7347 5.79218C16.7517 5.68518 16.8277 5.61418 16.9707 5.58118L16.8057 5.53418Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_15"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_11472_48389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M18.0713 8.72607V11.4961L21.2153 14.076V7.20007C21.2153 6.66907 21.1073 6.30907 20.8883 6.12207V7.55405L18.0713 8.72607Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_16"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_11472_48389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M18.7032 13.7703H18.6143V7.9043H18.7032V13.7703Z",
    fill: "#F6D728"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_17"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask16_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_11472_48389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M19.3605 13.7703H19.2715V7.9043H19.3605V13.7703Z",
    fill: "#F6D728"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_18"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_11472_48389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M20.0177 13.7703H19.9287V7.9043H20.0177V13.7703Z",
    fill: "#F6D728"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_19"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask18_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_11472_48389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M20.674 13.7703H20.5859V7.9043H20.674V13.7703Z",
    fill: "#F6D728"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_20"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask19_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_11472_48389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M17.4609 9.24304C19.5729 9.24304 20.4649 8.56102 20.9119 8.04602V6.14804C21.1429 6.08204 21.2699 5.91002 21.2869 5.62802C20.6289 6.16902 19.5969 4.90103 18.9859 6.21603C19.3159 6.87203 19.9719 6.80403 20.2069 6.42703C20.6769 6.82503 20.3009 8.32701 17.4609 8.30401V9.24304Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_21"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask20_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_11472_48389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M18.2349 13.8389C18.0709 14.0519 18.2119 14.2409 18.3529 14.3119C18.3039 14.1689 18.3299 14.0389 18.4239 13.9139L18.2349 13.8389Z",
    fill: "#CA001C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_22"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask21_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_11472_48389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M18.3672 14.308C18.2712 14.287 18.1792 14.206 18.1542 14.093C18.1342 14.009 18.1592 13.917 18.2232 13.833L18.2452 13.851C18.1842 13.929 18.1642 14.009 18.1812 14.089C18.2062 14.189 18.2882 14.265 18.3602 14.296C18.2912 14.169 18.3162 14.032 18.4122 13.901C18.3442 14.042 18.3232 14.169 18.3672 14.308Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_23"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask22_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_11472_48389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M19.058 14.6396C19.073 14.7336 19.026 14.8506 18.917 14.9936C19.199 14.9216 19.316 14.8256 19.222 14.6636L19.058 14.6396Z",
    fill: "#CA001C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_24"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask23_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_11472_48389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M18.9209 15.0047C19.0119 14.8467 19.0579 14.7317 19.0419 14.6417L19.0719 14.6377C19.0879 14.7357 19.0399 14.8587 18.9269 14.9987C19.0999 14.9287 19.1999 14.8757 19.2279 14.8077C19.2469 14.7687 19.2389 14.7237 19.2079 14.6707C19.2699 14.7177 19.2759 14.7727 19.2579 14.8187C19.2239 14.8967 19.1159 14.9557 18.9209 15.0047Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_25"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask24_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_11472_48389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M19.9951 14.2859C20.0431 14.3969 20.0511 14.5219 20.0201 14.6629C20.2311 14.4739 20.3001 14.2179 20.1361 14.1689L19.9951 14.2859Z",
    fill: "#CA001C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_26"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask25_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_11472_48389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M20.0295 14.6724C20.0345 14.5224 20.0275 14.3974 19.9795 14.2914L20.0085 14.2814C20.0565 14.3924 20.0645 14.5214 20.0315 14.6664C20.1455 14.5274 20.2305 14.3655 20.2075 14.2645C20.1985 14.2215 20.1725 14.1944 20.1315 14.1844C20.1925 14.1684 20.2245 14.2054 20.2365 14.2564C20.2645 14.3694 20.1775 14.5394 20.0295 14.6724Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_27"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask26_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_11472_48389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M19.9732 13.4415C20.0512 13.4595 20.1282 13.5335 20.2072 13.6755C20.2312 13.4175 20.1842 13.2775 19.9492 13.2305L19.9732 13.4415Z",
    fill: "#CA001C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_28"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask27_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_11472_48389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M20.2213 13.6791C20.1193 13.5501 20.0433 13.4721 19.9693 13.4561L19.9753 13.4291C20.0583 13.4451 20.1413 13.5271 20.2213 13.6691C20.2193 13.3991 20.1533 13.2861 19.9463 13.2451C20.2073 13.2671 20.2443 13.4311 20.2213 13.6791Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_29"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask28_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_11472_48389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M17.9072 12.6683L19.0122 13.6763C19.0122 13.6763 18.5892 13.7703 18.4252 13.7703C18.2592 13.7703 18.1192 13.8173 18.1662 13.8663C18.2132 13.9133 18.3052 13.9133 18.3542 13.9813C18.4002 14.0513 18.4712 14.1473 18.5642 14.0513C18.6592 13.9593 18.9872 13.8653 18.9872 13.8653C18.9872 13.8653 18.9872 14.4043 18.9642 14.4723C18.9422 14.5443 18.8702 14.6833 18.9182 14.6833C18.9642 14.6833 18.9642 14.6613 19.1532 14.6833C19.3392 14.7083 19.3172 14.7553 19.2692 14.4723C19.2222 14.1933 19.2462 13.8883 19.2462 13.8883C19.2462 13.8883 19.6682 14.1673 19.8092 14.3573C19.9502 14.5453 19.9272 14.4043 19.9962 14.3323C20.0682 14.2643 20.1602 14.2403 20.2322 14.2173C20.3012 14.1943 20.0442 14.1213 19.9732 14.0743C19.9022 14.0273 19.3642 13.7223 19.3642 13.7223C19.3642 13.7223 19.6682 13.6283 19.8562 13.6033C20.0442 13.5823 20.0442 13.5823 20.0212 13.4883C19.9962 13.3943 20.0212 13.2993 20.0212 13.2543C20.0212 13.2093 19.9962 13.1603 19.8782 13.2543C19.7622 13.3483 19.2222 13.5823 19.2222 13.5823L18.3052 12.3633L17.9072 12.6683Z",
    fill: "#CA001C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_30"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask29_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_11472_48389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M19.2745 14.718C19.2605 14.718 19.2445 14.716 19.2205 14.712L19.1495 14.702C19.0155 14.685 18.9785 14.692 18.9515 14.694L18.8905 14.688C18.8745 14.665 18.8945 14.612 18.9265 14.53L18.9485 14.471C18.9685 14.416 18.9715 14.018 18.9715 13.866C18.9565 13.889 18.6605 13.977 18.5735 14.065C18.5445 14.092 18.5125 14.11 18.4755 14.104C18.4195 14.1 18.3795 14.045 18.3395 13.991C18.3175 13.954 18.2755 13.936 18.2375 13.921C18.2055 13.909 18.1755 13.898 18.1535 13.876L18.1465 13.868L18.1425 13.833C18.1635 13.782 18.3015 13.757 18.4225 13.757C18.5825 13.757 18.9995 13.663 19.0055 13.663L17.8965 12.679L17.9165 12.657L19.0185 13.665C18.9955 13.694 18.5845 13.786 18.4225 13.786C18.2815 13.786 18.1795 13.821 18.1695 13.843C18.1915 13.872 18.2175 13.884 18.2475 13.894C18.2865 13.912 18.3335 13.929 18.3635 13.974C18.3965 14.025 18.4345 14.072 18.4775 14.076C18.5025 14.08 18.5275 14.068 18.5505 14.043C18.6465 13.945 18.9655 13.855 18.9805 13.852C18.9975 13.889 18.9975 14.409 18.9745 14.483L18.9515 14.542C18.9355 14.581 18.9055 14.661 18.9145 14.673C18.9735 14.665 19.0145 14.657 19.1495 14.673L19.2235 14.687C19.2485 14.691 19.2755 14.697 19.2815 14.691C19.2885 14.683 19.2815 14.64 19.2715 14.586L19.2505 14.481C19.2045 14.202 19.2255 13.893 19.2275 13.891C19.2675 13.891 19.6745 14.166 19.8185 14.35C19.8715 14.424 19.8835 14.434 19.9075 14.44C19.9165 14.44 19.9275 14.42 19.9355 14.397C19.9485 14.376 19.9605 14.348 19.9815 14.327C20.0455 14.264 20.1295 14.235 20.1965 14.216C20.2185 14.202 20.1445 14.171 20.0955 14.152C20.0435 14.131 19.9895 14.111 19.9625 14.093C19.8905 14.046 19.3525 13.741 19.3525 13.741C19.3585 13.714 19.6645 13.62 19.8505 13.596C19.9465 13.584 19.9985 13.576 20.0105 13.561C20.0175 13.553 20.0105 13.53 20.0015 13.495C19.9845 13.427 19.9915 13.358 19.9975 13.307C19.9995 13.285 20.0015 13.27 20.0015 13.258C19.9785 13.215 19.9545 13.213 19.8855 13.27C19.7675 13.366 19.2465 13.588 19.2235 13.6L18.2905 12.375L19.2285 13.576C19.2265 13.564 19.7515 13.338 19.8655 13.246C19.9265 13.197 19.9705 13.18 20.0015 13.193C20.0145 13.201 20.0295 13.215 20.0295 13.258C20.0295 13.27 20.0275 13.287 20.0265 13.311C20.0205 13.358 20.0135 13.424 20.0295 13.491C20.0395 13.532 20.0475 13.557 20.0335 13.579C20.0155 13.604 19.9705 13.608 19.8525 13.622C19.6815 13.645 19.4095 13.727 19.3685 13.741C19.4245 13.745 19.9105 14.022 19.9765 14.069C20.0015 14.083 20.0555 14.106 20.1055 14.126C20.2165 14.171 20.2535 14.186 20.2535 14.21L20.2025 14.245C20.1365 14.265 20.0605 14.288 20.0015 14.347C19.9835 14.367 19.9725 14.392 19.9635 14.413C19.9465 14.44 19.9345 14.468 19.9095 14.47C19.8805 14.472 19.8465 14.443 19.7915 14.37C19.6615 14.194 19.2795 13.938 19.2365 13.907C19.2515 13.938 19.2345 14.222 19.2795 14.475L19.2975 14.58C19.3145 14.662 19.3185 14.695 19.3015 14.711C19.2985 14.716 19.2865 14.718 19.2745 14.718Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_31"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask30_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_11472_48389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M17.0393 15.7182L17.5333 15.1302C18.0973 15.4762 18.5103 15.3802 18.7753 14.8512C17.9303 14.9942 17.5333 14.2242 17.5793 12.5522L18.2133 13.5342V12.6222L18.9863 12.7162L16.9453 10.5342L17.0393 15.7182Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_32"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask31_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_11472_48389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M16.0072 8.72607V11.4961L12.8643 14.076V7.20007C12.8643 6.66907 12.9742 6.30907 13.1922 6.12207V7.55405L16.0072 8.72607Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_33"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask32_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_11472_48389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M15.4649 13.7703H15.377V7.9043H15.4649V13.7703Z",
    fill: "#F6D728"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_34"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask33_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_11472_48389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M14.8067 13.7703H14.7197V7.9043H14.8067V13.7703Z",
    fill: "#F6D728"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_35"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask34_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_11472_48389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M14.1495 13.7703H14.0615V7.9043H14.1495V13.7703Z",
    fill: "#F6D728"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_36"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask35_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_11472_48389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M13.4943 13.7703H13.4043V7.9043H13.4943V13.7703Z",
    fill: "#F6D728"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_37"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask36_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_11472_48389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M16.618 9.24304C14.505 9.24304 13.6139 8.56102 13.1679 8.04602V6.14804C12.9329 6.08204 12.8089 5.91002 12.7939 5.62802C13.4499 6.16902 14.4819 4.90103 15.0919 6.21603C14.7649 6.87203 14.1069 6.80403 13.8719 6.42703C13.4039 6.82503 13.778 8.32701 16.618 8.30401V9.24304Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_38"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask37_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_11472_48389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M15.8432 13.8389C16.0072 14.0519 15.8682 14.2409 15.7252 14.3119C15.7742 14.1689 15.7482 14.0389 15.6572 13.9139L15.8432 13.8389Z",
    fill: "#CA001C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_39"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask38_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_11472_48389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M15.7316 14.323C15.7566 14.169 15.7356 14.042 15.6426 13.921C15.7616 14.032 15.7856 14.169 15.7386 14.316C15.7886 14.265 15.8726 14.189 15.8956 14.089C15.9136 14.009 15.8916 13.929 15.8296 13.851L15.8526 13.833C15.9186 13.917 15.9436 14.009 15.9236 14.093C15.8996 14.206 15.8096 14.286 15.7316 14.323Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_40"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask39_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_11472_48389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M15.0198 14.6396C15.0048 14.7336 15.0518 14.8506 15.1608 14.9936C14.8798 14.9216 14.7648 14.8256 14.8558 14.6636L15.0198 14.6396Z",
    fill: "#CA001C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_41"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask40_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_11472_48389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M15.1756 14.9807C14.9616 14.9557 14.8546 14.8967 14.8226 14.8187C14.8016 14.7717 14.8076 14.7167 14.8436 14.6547C14.8386 14.7227 14.8306 14.7677 14.8476 14.8067C14.8786 14.8747 14.9806 14.9277 15.1646 14.9747C15.0386 14.8577 14.9906 14.7347 15.0056 14.6367L15.0366 14.6407C15.0196 14.7307 15.0656 14.8467 15.1756 14.9807Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_42"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask41_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_11472_48389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M14.0832 14.2859C14.0362 14.3969 14.0292 14.5219 14.0602 14.6629C13.8482 14.4739 13.7782 14.2179 13.9422 14.1689L14.0832 14.2859Z",
    fill: "#CA001C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_43"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask42_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_11472_48389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M14.0731 14.6583C13.9011 14.5393 13.8151 14.3693 13.8431 14.2563C13.8531 14.2053 13.8871 14.1683 13.9391 14.1543C13.9071 14.1933 13.8801 14.2203 13.8721 14.2633C13.8481 14.3653 13.9331 14.5273 14.0711 14.6503C14.0141 14.5213 14.0221 14.3923 14.0711 14.2813L14.0981 14.2913C14.0511 14.3963 14.0441 14.5213 14.0731 14.6583Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_44"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask43_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_11472_48389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M14.1054 13.4415C14.0284 13.4595 13.9484 13.5335 13.8714 13.6755C13.8484 13.4175 13.8954 13.2775 14.1304 13.2305L14.1054 13.4415Z",
    fill: "#CA001C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_45"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask44_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_11472_48389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M13.8844 13.6848C13.8344 13.4308 13.8714 13.2668 14.1264 13.2158C13.9254 13.2858 13.8604 13.3998 13.8864 13.6748C13.9404 13.5248 14.0204 13.4448 14.1024 13.4288L14.1094 13.4558C14.0354 13.4718 13.9604 13.5498 13.8844 13.6848Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_46"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask45_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_11472_48389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M16.1708 12.6683L15.0688 13.6763C15.0688 13.6763 15.4918 13.7703 15.6568 13.7703C15.8198 13.7703 15.9618 13.8173 15.9148 13.8663C15.8688 13.9133 15.7738 13.9133 15.7258 13.9813C15.6798 14.0513 15.6108 14.1473 15.5158 14.0513C15.4208 13.9593 15.0928 13.8653 15.0928 13.8653C15.0928 13.8653 15.0928 14.4043 15.1158 14.4723C15.1388 14.5443 15.2108 14.6833 15.1618 14.6833C15.1158 14.6833 15.1158 14.6613 14.9298 14.6833C14.7408 14.7083 14.7658 14.7553 14.8118 14.4723C14.8578 14.1933 14.8348 13.8883 14.8348 13.8883C14.8348 13.8883 14.4128 14.1673 14.2738 14.3573C14.1318 14.5453 14.1558 14.4043 14.0848 14.3323C14.0158 14.2643 13.9208 14.2403 13.8508 14.2173C13.7808 14.1943 14.0388 14.1213 14.1088 14.0743C14.1788 14.0273 14.7178 13.7223 14.7178 13.7223C14.7178 13.7223 14.4128 13.6283 14.2268 13.6033C14.0378 13.5823 14.0378 13.5823 14.0628 13.4883C14.0858 13.3943 14.0628 13.2993 14.0628 13.2543C14.0628 13.2093 14.0858 13.1603 14.2028 13.2543C14.3208 13.3483 14.8588 13.5823 14.8588 13.5823L15.7758 12.3633L16.1708 12.6683Z",
    fill: "#CA001C"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_47"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask46_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_11472_48389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M14.8024 14.7175C14.7904 14.7175 14.7813 14.7155 14.7733 14.7076C14.7563 14.6916 14.7623 14.6585 14.7783 14.5765L14.7963 14.4715C14.8403 14.2095 14.8234 13.9226 14.8194 13.8896C14.8044 13.9266 14.4143 14.1905 14.2823 14.3665C14.2273 14.4385 14.1933 14.4686 14.1653 14.4666C14.1403 14.4646 14.1274 14.4375 14.1134 14.4095C14.1024 14.3875 14.0913 14.3625 14.0723 14.3445C14.0133 14.2845 13.9383 14.2605 13.8723 14.2415L13.8223 14.2065C13.8203 14.1835 13.8573 14.1675 13.9693 14.1225C14.0213 14.1025 14.0734 14.0796 14.0994 14.0656C14.1644 14.0186 14.6363 13.7525 14.7023 13.7155C14.6533 13.7155 14.3903 13.6416 14.2244 13.6176C14.1064 13.6036 14.0634 13.5996 14.0434 13.5746C14.0304 13.5536 14.0363 13.5275 14.0473 13.4865C14.0633 13.4205 14.0563 13.3535 14.0503 13.3065C14.0483 13.2835 14.0473 13.2655 14.0473 13.2535C14.0473 13.2105 14.0634 13.1965 14.0744 13.1885C14.1054 13.1745 14.1493 13.1925 14.2113 13.2415C14.3253 13.3335 14.8573 13.5655 14.8653 13.5675L15.7623 12.3525L14.8693 13.5905C14.8293 13.5825 14.3093 13.3606 14.1913 13.2646C14.1233 13.2076 14.0954 13.2095 14.0874 13.2135C14.0724 13.2645 14.0763 13.2795 14.0763 13.3015C14.0833 13.3525 14.0913 13.4205 14.0723 13.4895C14.0633 13.5245 14.0594 13.5485 14.0654 13.5555C14.0764 13.5715 14.1303 13.5785 14.2244 13.5905C14.4104 13.6135 14.7163 13.7076 14.7193 13.7076C14.7233 13.7345 14.1833 14.0395 14.1143 14.0865C14.0853 14.1045 14.0303 14.1235 13.9783 14.1455C13.9303 14.1655 13.8564 14.1966 13.8494 14.2086C13.9444 14.2296 14.0283 14.2595 14.0923 14.3215C14.1133 14.3425 14.1274 14.3705 14.1384 14.3915C14.1474 14.4145 14.1593 14.4345 14.1673 14.4345C14.1833 14.4285 14.2023 14.4185 14.2583 14.3445C14.3993 14.1605 14.8073 13.8855 14.8253 13.8735C14.8463 13.8875 14.8693 14.1956 14.8233 14.4756L14.8043 14.5805C14.7933 14.6355 14.7843 14.6785 14.7913 14.6855C14.7953 14.6915 14.8243 14.6855 14.8513 14.6815L14.9243 14.6675C15.0613 14.6515 15.1013 14.6595 15.1283 14.6635C15.1673 14.6555 15.1384 14.5735 15.1214 14.5365L15.0993 14.4775C15.0763 14.4035 15.0763 13.8835 15.0763 13.8625C15.1093 13.8505 15.4283 13.9405 15.5233 14.0385C15.5473 14.0635 15.5754 14.0755 15.5954 14.0715C15.6394 14.0675 15.6783 14.0205 15.7093 13.9695C15.7403 13.9245 15.7863 13.9066 15.8273 13.8896C15.8563 13.8796 15.8833 13.8686 15.9003 13.8506C15.8953 13.8176 15.7943 13.7825 15.6533 13.7825C15.4883 13.7825 15.0803 13.6906 15.0623 13.6866L16.1593 12.6535L16.1793 12.6755L15.0793 13.6835C15.1173 13.6695 15.5003 13.7535 15.6543 13.7535C15.7723 13.7535 15.9124 13.7785 15.9314 13.8295L15.9353 13.8355L15.9213 13.8725C15.8993 13.8935 15.8703 13.9055 15.8383 13.9175C15.7993 13.9335 15.7603 13.9505 15.7343 13.9875C15.6973 14.0425 15.6553 14.0966 15.5983 14.1006C15.5653 14.1066 15.5334 14.0886 15.5004 14.0616C15.4094 13.9696 15.0873 13.8766 15.0853 13.8766C15.1033 14.0116 15.1074 14.4135 15.1264 14.4685L15.1474 14.5255C15.1804 14.6095 15.1994 14.6625 15.1824 14.6855L15.1223 14.6915C15.0963 14.6895 15.0573 14.6816 14.9263 14.6996L14.8533 14.7095C14.8323 14.7155 14.8164 14.7175 14.8024 14.7175Z",
    fill: "black"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_48"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask47_11472_48389",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000153679188644278612020000015675038462459891607__44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M33.8218 0.385742H0.257812V19.9637H33.8218V0.385742Z",
    fill: "white"
  })))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_11472_48389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M17.0388 15.7182L16.5468 15.1302C15.9838 15.4762 15.5698 15.3802 15.3048 14.8512C16.1478 14.9942 16.5468 14.2242 16.4988 12.5522L15.8678 13.5342V12.6222L15.0918 12.7162L17.1328 10.5342L17.0388 15.7182Z",
    fill: "black"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGermany);
export default __webpack_public_path__ + "static/media/GERMANY.f77455f098e78a5134d273f1e4314615.svg";
export { ForwardRef as ReactComponent };